import React from "react";
import { Tab } from "semantic-ui-react";
import Tubes from "features/FolderManager/components/Tubes";

const TubesContent = ({
	data,
	disabled,
	user,
	generalParameters,
	patchUntakenTube,
	getAllTubeUntakenReasons,
	submitAddTubeModal,
	openDeleteNotPrescribedTubeConfirm,
	patchMultipleTubes,
	loadAddTubeModalData,
	patchTubeSamplingTime,
	cancelReuseTube,
	getReusableTubes,
	getAllTubeNatureReasons,
	patchTubeNature,
	getMissingVolumeTubes,
	submitDeleteNotPrescribedTubeConfirm,
	tubeReducer,
}) => {
	return (
		<Tab.Pane style={{ marginTop: 20 }}>
			{!data.allAnalysesChecked && <span>Veuillez vérifier toutes les analyses de la ou des prescriptions avant de prélever.</span>}
			{data.allAnalysesChecked && data.tubes.filter((t) => !t.properties.aliquot).length > 0 && (
				<Tubes
					key="tubes"
					folder={data.folders}
					tubes={data.tubes}
					aliquot={false}
					take_number={data.take_number}
					patchUntakenTube={patchUntakenTube}
					getAllTubeUntakenReasons={getAllTubeUntakenReasons}
					submitAddTubeModal={submitAddTubeModal}
					openDeleteNotPrescribedTubeConfirm={openDeleteNotPrescribedTubeConfirm}
					patchMultipleTubes={patchMultipleTubes}
					user={user}
					loadAddTubeModalData={loadAddTubeModalData}
					patchTubeSamplingTime={patchTubeSamplingTime}
					disabled={disabled}
					tubeReducer={tubeReducer}
					cancelReuseTube={cancelReuseTube}
					getReusableTubes={getReusableTubes}
					getAllTubeNatureReasons={getAllTubeNatureReasons}
					patchTubeNature={patchTubeNature}
					getMissingVolumeTubes={getMissingVolumeTubes}
					submitDeleteNotPrescribedTubeConfirm={submitDeleteNotPrescribedTubeConfirm}
					isHome={data.isHome}
					safeplaceResult={data.prescriptions && data.prescriptions.length > 0 ? data.prescriptions[0].safeplace_result : null}
					urgencyPretreatementLimit={generalParameters.data.urgencyPretreatementLimit}
					isDeposit={data.deposit}
				/>
			)}
		</Tab.Pane>
	);
};
export default TubesContent;
